import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=469a2167&scoped=true&lang=pug&"
import script from "./LinkButton.vue?vue&type=script&lang=js&"
export * from "./LinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469a2167",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469a2167')) {
      api.createRecord('469a2167', component.options)
    } else {
      api.reload('469a2167', component.options)
    }
    module.hot.accept("./LinkButton.vue?vue&type=template&id=469a2167&scoped=true&lang=pug&", function () {
      api.rerender('469a2167', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/buttons/LinkButton.vue"
export default component.exports